import React from "react";
import ReactDOM from "react-dom/client";
/*import './index.css';*/
import "./sass/persitent-header.scss";
import { getInitialProps } from "./initialize";
import { startRum } from "./datadog-rum";

// Temporary interace testing
// import App from './App.js'; // This is the backend testing interface (For Auth, Deere Developer, and Backend testing)
// import TestInterface from './testInterface/TestInterface'; // This is the deprecated old version of the frontend
// import Interface from './newInterface/Interface.tsx'; // This is the main frontend view
// import MQTTIntlerface from './testInterface/MQTTInterface'; // This is the "Engineering tool view"
// Main interface, all test interfaces merge to here
// import MainInterface from './mainInterface/Interface.tsx';
import { App } from "./mainInterface/Main";
import { NoAccess } from "./NoAccess";
import { useState, useEffect } from "react";
import { Alert } from "@deere/isg.component-library";
import { IconLoading } from "@deere/icons/new";

const Bootstrap = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [initialProps, setInitialProps] = useState(null);

  useEffect(() => {
    getInitialProps()
      .then((props) => {
        startRum(props.userInfo);
        setInitialProps(props);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Initialization failed:", err);
        setError(err);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          flexDirection: "column",
        }}
      >
        <style>
          {`
                    @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                    `}
        </style>
        <div style={{ animation: "spin 1500ms linear infinite" }}>
          <IconLoading size={64} />
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: "2rem", maxWidth: "800px", margin: "0 auto" }}>
        <Alert severity="error" title="Application Error">
          Failed to initialize application. Please try refreshing the page.
          <br />
          <small>{error.message || String(error)}</small>
        </Alert>
      </div>
    );
  }

  // Gate the main app on the backend's hasPermissions flag. Users
  // without a permissions DB entry get the contact-admin page instead.
  // The backend's RBAC guard and WS gateway enforce the same boundary;
  // this is purely the UI surface.
  if (initialProps.userInfo && initialProps.userInfo.hasPermissions !== true) {
    return <NoAccess user={initialProps.userInfo} />;
  }

  return <App user={initialProps.userInfo} />;
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Bootstrap />);

// reportWebVitals();
